import axiosApi from "scripts/components/react/api/ajaxToAxios"
import { apiRequest, ApiResult } from "scripts/types/api"

export type ProfileUpdatePayload = {
  name: string
  last_name: string
  email: string
  birthday: string
  subscribe?: boolean
  gender?: string
}

export type ProfileResponse = ApiResult<{
  name: string
  last_name: string
  email: string
  birthday: string
  subscribe: boolean
  gender: string
  phone: string
  birthdayDiscountPercent: number
  birthdayDiscountRange: null | {
    start: {
      day: number
      date: string
    }
    end: {
      day: number
      date: string
    }
  }
}>

export const getProfileData: () => Promise<ProfileResponse> = () =>
  apiRequest(axiosApi("/api/personal/profile", { method: "GET" }))

export const updateProfile = (data: ProfileUpdatePayload) =>
  apiRequest(
    axiosApi("/api/personal/profile/update/", {
      method: "POST",
      data: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    }),
  )

export const getPersonalData = () => apiRequest(axiosApi("/personal/", { method: "GET" }))
